//////// GHG 3.14 EA
const threeFourteenSchema = {
  title: "3.14 Franchise (Scope 1 and Scope 2)",
  addAPI: "cat6_1AddEmissionActivityAPI",
  cat: "cat6_1",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Activity Name",
      resetOnChange: false,
      required: true,
    },
    //////// Activity Type
    {
      key: "ghgActivityNameId",
      level: 1,
      type: "select",
      label: "Activity Type",
      optionsAPI: "ghg3_14EADropdownAPI",
      required: true,
      resetOnChange: false,
    },
  ],
};
export default threeFourteenSchema;
